<form class="edit-form" *ngIf="!isLoading && editForm" [formGroup]="editForm" (submit)="onSubmit()">
  <section class="autocompleteSite">
    <app-autocomplete [control]="getControl('site')" [list]="sites" label="billing.schedules.list.site">
    </app-autocomplete>
  </section>

  <section class="autocompleteGroup">
    <app-autocomplete [control]="getControl('holidayGroup')" [list]="holidayGroups"
      label="billing.schedules.list.holidayGroup">
    </app-autocomplete>
  </section>

  <mat-form-field class="startDayTime-field">
    <mat-label>Heure de début</mat-label>
    <input id="startDayTime" type="time" matInput formControlName="startDayTime">
  </mat-form-field>

  <mat-form-field class="endDayTime-field">
    <mat-label>Heure de fin</mat-label>
    <input id="endDayTime" type="time" matInput formControlName="endDayTime">
  </mat-form-field>

  <section class="day-field" *ngIf="editForm.value.site">
    <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" multiple="true"
      [value]="daysPreselected">
      <mat-button-toggle *ngFor="let day of days" [value]="day" [disabled]="day.disabled"
        (change)="selectDay($event, day)">
        {{showDayText(day.value) | translate}}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </section>

  <p class="noCanDo" *ngIf="!canChooseNoDays && daysSelected.length === 0">Il y a déjà un horaire pour ce donneur
    d'ordre sans jours.</p>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm" class="actions"
    [disabling]="editForm.invalid || (!canChooseNoDays && daysSelected.length === 0)"></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>